import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  plugins: [
    createPersistedState()
  ],
  state: {
    token: null,
    user: null,
    isUserLoggedIn: false,
    isWebexLoginMode: false,
    settings: null,
    locale: null
  },
  getters: {
    user: state => {
      console.log(state);
      return state.user;
    },
    token: state => {
      return state.token;
    }
  },
  mutations: {
    setToken (state, token) {
      state.token = token;
      if (token) {
        state.isUserLoggedIn = true;
      } else {
        state.isUserLoggedIn = false;
      }
    },
    setWebexLoginMode (state, isLoginMode) {
      if (isLoginMode) {
        state.isWebexLoginMode = true;
      } else {
        state.isWebexLoginMode = false;
      }
    },
    setUser (state, user) {
      console.log(`Store setUser`, user);
      state.user = user;
    },
    updateUser (state, updateUser) {
      state.user['company'] = updateUser.company;
      state.user['address'] = updateUser.address;
      state.user['department'] = updateUser.department;
      state.user['team'] = updateUser.team;
      state.user['position'] = updateUser.position;
      state.user['aboutme'] = updateUser.aboutme;
      state.user['avatar'] = updateUser.avatar;
    },
    setSettings (state, settings) {
      state.settings = settings;
    },
    setLocale (state, locale) {
      state.locale = locale;
    },
  },
  actions: {
    setToken ({ commit }, token) {
      commit('setToken', token);
    },
    setUser ({ commit }, user) {
      commit('setUser', user);
    },
    updateUser ({ commit }, updateUser) {
      commit('updateUser', updateUser);
    },
    setSettings ({ commit }, settings) {
      commit('setSettings', settings);
    },
    setLocale ({ commit }, locale) {
      commit('setLocale', locale);
    },
    setAgree ({ commit }, agreeInfo) {
      commit('setAgree', agreeInfo);
    },
    setPageState ({ commit }, page) {
      commit('setPageState', page);
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js